import { getCasdoorURL } from "./serverUrl";

const getDefaultLogoutState = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}`;
};

const isValidToken = (token) =>
  Boolean(token) && token !== "null" && token !== "undefined";

export const postLogoutWithFormBody = async ({
  serverURL,
  token,
  redirectUri,
  state = getDefaultLogoutState(),
}) => {
  if (!isValidToken(token)) {
    throw new Error(`Token is invalid: ${token}`);
  }

  const clientId = process.env.REACT_APP_CLIENT_ID;
  if (!clientId) {
    throw new Error("REACT_APP_CLIENT_ID is not configured");
  }

  const response = await fetch(`${serverURL}/api/clear-session`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Logout request failed with status ${response.status}`);
  }

  const result = await response.json();
  if (result.status !== "ok") {
    throw new Error(result.msg || "Regional logout failed");
  }

  // Preserve UI preferences such as the last selected organization/site.
  // Authentication state must still be removed before leaving the portal.
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("usage_emulator_config");
  sessionStorage.clear();

  // Use a top-level POST so the browser sends the host-only central SSO cookie.
  // The regional call above expires its local token and clears its session.
  // Central logout uses the client ID so it does not depend on a regional
  // token database, and remains the single source of the logout webhook.
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${getCasdoorURL()}/api/logout`;

  const fields = {
    client_id: clientId,
    post_logout_redirect_uri: redirectUri,
    state,
  };
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};
